































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import { MedicaoGlicemia } from '../../../../back/src/entity/MedicaoGlicemia';
import { momentosMedicoesGlicemiaStrings } from '../../utils/constants';
import { IntervaloRefeicao } from '../../../../back/src/types';

export default Vue.extend({
  name: 'MedicaoGlicemiaDados',
  components: {
    IfEmptyTextPrintNA,
  },
  props: {
    medicaoGlicemia: {
      type: Object as () => MedicaoGlicemia,
    },
  },
  data() {
    return {
      momentosMedicoesGlicemiaStrings,
    };
  },
  computed: {
    medicaoGlicemiaData(): string {
      const momentDate = moment(this.medicaoGlicemia.data_medicao).utc();
      if (momentDate.isValid()) {
        return momentDate.format('DD/MM/YYYY');
      }
      return '';
    },
    momentoString(): string {
      return this.momentosMedicoesGlicemiaStrings[
        this.medicaoGlicemia.momento
      ];
    },
    tempoMedicaoString() {
      if (!this.medicaoGlicemia.intervalo_refeicao) return null;
      return this.medicaoGlicemia.intervalo_refeicao;
    },
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
    medidaClass(): string {
      if (this.medicaoGlicemia.momento === 'JE') {
        // medicao em jejum
        if (this.medicaoGlicemia.medida >= 95) return 'warning--text';
        return '';
      }
      // medicao pós refeicao ou avulsa
      if (this.medicaoGlicemia.intervalo_refeicao === IntervaloRefeicao['1h']) {
        if (this.medicaoGlicemia.medida < 130) return '';
        if (this.medicaoGlicemia.medida < 140) return 'coletivo_nascer--text';
        if (this.medicaoGlicemia.medida < 180) return 'warning--text';
      } else {
        if (this.medicaoGlicemia.medida < 110) return '';
        if (this.medicaoGlicemia.medida < 120) return 'coletivo_nascer--text';
        if (this.medicaoGlicemia.medida < 180) return 'warning--text';
      }
      return 'error--text';
    },
  },
});
